import extend from './extend';
import * as MessageTesting from './survey.template-message-testing';
export { MessageTesting };
export var SurveyTemplateType;
(function (SurveyTemplateType) {
    SurveyTemplateType[SurveyTemplateType["None"] = 0] = "None";
    SurveyTemplateType[SurveyTemplateType["CompetitiveIntelligence"] = 1] = "CompetitiveIntelligence";
    SurveyTemplateType[SurveyTemplateType["PersonaResearch"] = 2] = "PersonaResearch";
    SurveyTemplateType[SurveyTemplateType["NetPromoterScore"] = 3] = "NetPromoterScore";
    SurveyTemplateType[SurveyTemplateType["EmployeeSatisfaction"] = 4] = "EmployeeSatisfaction";
    SurveyTemplateType[SurveyTemplateType["PricingStrategy"] = 5] = "PricingStrategy";
    SurveyTemplateType[SurveyTemplateType["MarketingCampaignEffectiveness"] = 6] = "MarketingCampaignEffectiveness";
    SurveyTemplateType[SurveyTemplateType["MarketAnalysis"] = 7] = "MarketAnalysis";
    SurveyTemplateType[SurveyTemplateType["TargetProductProfile"] = 8] = "TargetProductProfile";
    SurveyTemplateType[SurveyTemplateType["ExternalSurvey"] = 9] = "ExternalSurvey";
    SurveyTemplateType[SurveyTemplateType["MessageTesting"] = 10] = "MessageTesting";
})(SurveyTemplateType || (SurveyTemplateType = {}));
const surveyTemplateTypeMap = new Map([
    [SurveyTemplateType.None, { name: 'None' }],
    [SurveyTemplateType.CompetitiveIntelligence, { name: 'Competitive Intelligence' }],
    [SurveyTemplateType.PersonaResearch, { name: 'Persona Research' }],
    [SurveyTemplateType.NetPromoterScore, { name: 'Net Promoter Score' }],
    [SurveyTemplateType.EmployeeSatisfaction, { name: 'Employee Satisfaction' }],
    [SurveyTemplateType.PricingStrategy, { name: 'Pricing Strategy' }],
    [SurveyTemplateType.MarketingCampaignEffectiveness, { name: 'Marketing Campaign Effectiveness' }],
    [SurveyTemplateType.MarketAnalysis, { name: 'Market Analysis' }],
    [SurveyTemplateType.TargetProductProfile, { name: 'Target Product Profile' }],
    [SurveyTemplateType.ExternalSurvey, { name: 'Use External Survey Platform' }],
    [SurveyTemplateType.MessageTesting, { name: 'Message Testing' }],
]);
export var CompetitiveIntelligenceTemplateSection;
(function (CompetitiveIntelligenceTemplateSection) {
    CompetitiveIntelligenceTemplateSection["Screening"] = "ci-screening";
    CompetitiveIntelligenceTemplateSection["CompetitorIndexing"] = "ci-competitor-indexing";
    CompetitiveIntelligenceTemplateSection["CompetitorRanking"] = "ci-competitor-ranking";
    CompetitiveIntelligenceTemplateSection["CurrentCustomer"] = "ci-current-customer";
    CompetitiveIntelligenceTemplateSection["FormerCustomer"] = "ci-former-customer";
})(CompetitiveIntelligenceTemplateSection || (CompetitiveIntelligenceTemplateSection = {}));
export var PersonaResearchTemplateSection;
(function (PersonaResearchTemplateSection) {
    PersonaResearchTemplateSection["Screening"] = "pr-screening";
    PersonaResearchTemplateSection["BudgetSpend"] = "pr-budget-spend";
    PersonaResearchTemplateSection["RoleEval"] = "pr-role-eval";
    PersonaResearchTemplateSection["DecisionMaking"] = "pr-decision-making";
})(PersonaResearchTemplateSection || (PersonaResearchTemplateSection = {}));
export var NetPromoterScoreTemplateSection;
(function (NetPromoterScoreTemplateSection) {
    NetPromoterScoreTemplateSection["Screening"] = "nps-screening";
    NetPromoterScoreTemplateSection["NetPromoterTargt"] = "nps-net-promoter-target";
    NetPromoterScoreTemplateSection["NetPromoterCompetitor"] = "nps-net-promoter-competitor";
})(NetPromoterScoreTemplateSection || (NetPromoterScoreTemplateSection = {}));
export var EmployeeSatisfactionTemplateSection;
(function (EmployeeSatisfactionTemplateSection) {
    EmployeeSatisfactionTemplateSection["Main"] = "es-main";
})(EmployeeSatisfactionTemplateSection || (EmployeeSatisfactionTemplateSection = {}));
export var PricingStrategySection;
(function (PricingStrategySection) {
    PricingStrategySection["Main"] = "ps-main";
})(PricingStrategySection || (PricingStrategySection = {}));
export var MarketingCampaignEffectivenessSection;
(function (MarketingCampaignEffectivenessSection) {
    MarketingCampaignEffectivenessSection["Targeting"] = "mce-targeting";
    MarketingCampaignEffectivenessSection["Solutions"] = "mce-solutions";
    MarketingCampaignEffectivenessSection["InHouseSolution"] = "mce-in-hous";
    MarketingCampaignEffectivenessSection["ThirdPartySolution"] = "mce-third-party";
    MarketingCampaignEffectivenessSection["NoSolution"] = "mce-no-solution";
    MarketingCampaignEffectivenessSection["AnySolution"] = "mce-any-solution";
    MarketingCampaignEffectivenessSection["Distribution"] = "mce-distribution";
})(MarketingCampaignEffectivenessSection || (MarketingCampaignEffectivenessSection = {}));
export var MarketAnalysisSection;
(function (MarketAnalysisSection) {
})(MarketAnalysisSection || (MarketAnalysisSection = {}));
export var TargetProductProfileSection;
(function (TargetProductProfileSection) {
    TargetProductProfileSection["Intro"] = "tpp-intro";
    TargetProductProfileSection["EUScreener"] = "tpp-eu-screener";
    TargetProductProfileSection["NonEUScreener"] = "tpp-non-eu-screener";
    TargetProductProfileSection["UnmetNeeds"] = "tpp-unmet-needs";
    TargetProductProfileSection["TPPAssessment"] = "tpp-assessment";
    TargetProductProfileSection["ClinicalComparators"] = "tpp-clinical-comparators";
    TargetProductProfileSection["USPricing"] = "tpp-us-pricing";
    TargetProductProfileSection["FrancePricing"] = "tpp-france-pricing";
    TargetProductProfileSection["SpainPricing"] = "tpp-spain-pricing";
    TargetProductProfileSection["ItalyPricing"] = "tpp-italy-pricing";
    TargetProductProfileSection["GermanyPricing"] = "tpp-germany-pricing";
    TargetProductProfileSection["UKPricing"] = "tpp-uk-pricing";
    TargetProductProfileSection["Canada"] = "tpp-canada";
    TargetProductProfileSection["EUAcceptablePrice"] = "tpp-eu-acceptable-price";
    TargetProductProfileSection["EUPricing"] = "tpp-eu-pricing";
    TargetProductProfileSection["EUPricingComparator"] = "tpp-eu-pricing-comparator";
    TargetProductProfileSection["GDPRDataController"] = "tpp-gdpr-controller";
    TargetProductProfileSection["Access"] = "tpp-access";
})(TargetProductProfileSection || (TargetProductProfileSection = {}));
export var SurveyTemplateOptionKey;
(function (SurveyTemplateOptionKey) {
    SurveyTemplateOptionKey["CurrentCustomer"] = "current-customer";
    SurveyTemplateOptionKey["FormerCustomer"] = "former-customer";
})(SurveyTemplateOptionKey || (SurveyTemplateOptionKey = {}));
export var SurveyTemplateEntityType;
(function (SurveyTemplateEntityType) {
    SurveyTemplateEntityType["Category"] = "category";
    SurveyTemplateEntityType["PricingComparator"] = "pricing-comparator";
    SurveyTemplateEntityType["TreatmentComparator"] = "treatment-comparator";
    SurveyTemplateEntityType["Competitor"] = "competitor";
    SurveyTemplateEntityType["DrugIndication"] = "drug-indication";
    SurveyTemplateEntityType["DrugPrice"] = "drug-price";
    SurveyTemplateEntityType["PrimaryEfficacyEndpoint"] = "primary-efficacy-endpoint";
    SurveyTemplateEntityType["CoPrimaryEfficacyEndpoint"] = "co-primary-efficacy-endpoint";
    SurveyTemplateEntityType["SecondaryEfficacyEndpoint"] = "secondary-efficacy-endpoint";
    SurveyTemplateEntityType["EvaluationCriteria"] = "evaluation-criteria";
    SurveyTemplateEntityType["OtherAttribute"] = "other-attribute";
    SurveyTemplateEntityType["PartnershipCriteria"] = "partnership-criteria";
    SurveyTemplateEntityType["QualityOfLife"] = "quality-of-life";
    SurveyTemplateEntityType["SafetyEndpoint"] = "safety-endpoint";
    SurveyTemplateEntityType["Target"] = "target";
    SurveyTemplateEntityType["TargetRole"] = "target-role";
    SurveyTemplateEntityType["TrialDesign"] = "trial-design";
    SurveyTemplateEntityType["DoseAdministration"] = "dose-administration";
    SurveyTemplateEntityType["MedicalSpecialty"] = "medical-specialty";
    SurveyTemplateEntityType["MedicalCondition"] = "medical-condition";
    SurveyTemplateEntityType["CategoryMessage"] = "category-message";
    SurveyTemplateEntityType["Attitudinal"] = "attitudinal";
})(SurveyTemplateEntityType || (SurveyTemplateEntityType = {}));
export var CommonTemplateQuestion;
(function (CommonTemplateQuestion) {
    CommonTemplateQuestion["OrganizationRevenue"] = "organization-revenue";
    CommonTemplateQuestion["OrganizationPrimaryIndustry"] = "organization-industry";
    CommonTemplateQuestion["RespondentRole"] = "respondent-role";
    CommonTemplateQuestion["RespondentDepartment"] = "respondent-department";
})(CommonTemplateQuestion || (CommonTemplateQuestion = {}));
export var PersonaResearchQuestion;
(function (PersonaResearchQuestion) {
    PersonaResearchQuestion["OrgCurrentCustomer"] = "pr-organization-current-customer";
    PersonaResearchQuestion["RespondentInvolvement"] = "pr-respondent-involvement";
    PersonaResearchQuestion["DepartmentBudget"] = "pr-department-budget";
    PersonaResearchQuestion["DepartmentSolutionsBudget"] = "pr-department-solutions-budget";
    PersonaResearchQuestion["OrganizationProducts"] = "pr-organization-products";
    PersonaResearchQuestion["OrganizationBusinessModel"] = "pr-organization-business-model";
    PersonaResearchQuestion["TopPriorities"] = "pr-top-priorities";
    PersonaResearchQuestion["TopChallenges"] = "pr-top-challenges";
    PersonaResearchQuestion["EvaluationCriteria"] = "pr-evaluation-critria";
    PersonaResearchQuestion["OtherEvaluationCriteria"] = "pr-other-evaluation-criteria";
    PersonaResearchQuestion["PartnershipCriteria"] = "pr-partnership-criteria";
    PersonaResearchQuestion["PartnershipCriteriaReason"] = "pr-partnership-criteria-reason";
    PersonaResearchQuestion["TargetRole"] = "pr-target-role";
    PersonaResearchQuestion["FinalDecisionMaker"] = "pr-final-decision-maker";
})(PersonaResearchQuestion || (PersonaResearchQuestion = {}));
export var CompetitiveIntelligenceQuestion;
(function (CompetitiveIntelligenceQuestion) {
    CompetitiveIntelligenceQuestion["OrgCurrentCustomer"] = "ci-organization-current-customer";
    CompetitiveIntelligenceQuestion["SubjectAwareness"] = "ci-subject-awareness";
    CompetitiveIntelligenceQuestion["SubjectBrandStrength"] = "ci-subject-brand-strength";
    CompetitiveIntelligenceQuestion["SubjectBrandStrengthReason"] = "ci-subject-brand-strength-reason";
    CompetitiveIntelligenceQuestion["SubjectPrice"] = "ci-subject-price";
    CompetitiveIntelligenceQuestion["SubjectPriceReason"] = "ci-subject-price-reason";
    CompetitiveIntelligenceQuestion["SubjectServiceQuality"] = "ci-subject-service-quality";
    CompetitiveIntelligenceQuestion["SubjectServiceQualityReason"] = "ci-subject-service-quality-reason";
    CompetitiveIntelligenceQuestion["SubjectProductValue"] = "ci-subject-product-value";
    CompetitiveIntelligenceQuestion["SubjectProductValueReason"] = "ci-subject-product-value-reason";
    CompetitiveIntelligenceQuestion["CurrentCustomerRationale"] = "ci-current-customer-rationale";
    CompetitiveIntelligenceQuestion["CurrentCustomerReplacementWillingness"] = "ci-current-customer-replacement-willingness";
    CompetitiveIntelligenceQuestion["CurrentCustomerReplacementRationale"] = "ci-current-customer-replacement-rationale";
    CompetitiveIntelligenceQuestion["CurrentCustomerReplacement"] = "ci-current-customer-replacement";
    CompetitiveIntelligenceQuestion["FormerCustomerRationale"] = "ci-former-customer-rationale";
    CompetitiveIntelligenceQuestion["FormerCustomerReplacement"] = "ci-former-customer-replacement";
})(CompetitiveIntelligenceQuestion || (CompetitiveIntelligenceQuestion = {}));
export var NetPromoterScoreQuestion;
(function (NetPromoterScoreQuestion) {
    NetPromoterScoreQuestion["RespondentEvaluationRole"] = "nps-evaluation-role";
    NetPromoterScoreQuestion["OrgCurrentCustomer"] = "nps-organization-current-customer";
    NetPromoterScoreQuestion["TargetRecommendation"] = "nps-target-recommendation";
    NetPromoterScoreQuestion["TargetRecommendationReason"] = "nps-target-recommendation-reason";
    NetPromoterScoreQuestion["TargetHigherRating"] = "nps-target-higher-rating";
    NetPromoterScoreQuestion["CompetitorRecommendation"] = "nps-competitor-recommendation";
    NetPromoterScoreQuestion["CompetitorRecommendationReason"] = "nps-competitor-recommendation-reason";
    NetPromoterScoreQuestion["CompetitorHigherRating"] = "nps-competitor-higher-rating";
})(NetPromoterScoreQuestion || (NetPromoterScoreQuestion = {}));
export var EmployeeSatisfactionQuestion;
(function (EmployeeSatisfactionQuestion) {
    EmployeeSatisfactionQuestion["CurrentEmployee"] = "es-current-employee";
    EmployeeSatisfactionQuestion["RespondentCommitted"] = "es-respondent-committed";
    EmployeeSatisfactionQuestion["ColleaguesCommitted"] = "es-colleagues-commited";
    EmployeeSatisfactionQuestion["OrgGoalsAligment"] = "es-org-goals-alignment";
    EmployeeSatisfactionQuestion["WorkEngaging"] = "es-work-engaging";
    EmployeeSatisfactionQuestion["CareerGrowth"] = "es-career-growth";
    EmployeeSatisfactionQuestion["CareerGoals"] = "es-career-goals";
    EmployeeSatisfactionQuestion["CareerGoalsElaboration"] = "es-career-goals-elaboration";
    EmployeeSatisfactionQuestion["NecessaryTools"] = "es-necessary-tools";
    EmployeeSatisfactionQuestion["Encouraged"] = "es-encouraged";
    EmployeeSatisfactionQuestion["FeedbackConsidered"] = "es-feedback-considered";
    EmployeeSatisfactionQuestion["Recognization"] = "es-recognization";
    EmployeeSatisfactionQuestion["RecognizationElaboration"] = "es-recognization-elaboration";
    EmployeeSatisfactionQuestion["Flexibility"] = "es-flexibility";
    EmployeeSatisfactionQuestion["Informed"] = "es-informed";
    EmployeeSatisfactionQuestion["UnderstandsChanges"] = "es-understands-changes";
    EmployeeSatisfactionQuestion["ChangesInLine"] = "es-changes-in-line";
    EmployeeSatisfactionQuestion["SupervisorCares"] = "es-supervisor-cares";
    EmployeeSatisfactionQuestion["SupervisorFeedback"] = "es-supervisor-feedback";
    EmployeeSatisfactionQuestion["MyResponsibilitiesClear"] = "es-my-responsibilities-clear";
    EmployeeSatisfactionQuestion["TeammateResponsibilitiesClear"] = "es-teammate-responsibilities-clear";
    EmployeeSatisfactionQuestion["LeadersTransparent"] = "es-leaders-transparent";
    EmployeeSatisfactionQuestion["Recommend"] = "es-recommend";
    EmployeeSatisfactionQuestion["EmployeeExperience"] = "es-employee-experience";
})(EmployeeSatisfactionQuestion || (EmployeeSatisfactionQuestion = {}));
export var PricingStrategyQuestion;
(function (PricingStrategyQuestion) {
    PricingStrategyQuestion["RecentCustomer"] = "ps-rececnt-customer";
    PricingStrategyQuestion["EvaluationInvolvement"] = "ps-evaluation-involvement";
    PricingStrategyQuestion["PerceivedValue"] = "ps-perceived-value";
    PricingStrategyQuestion["Awareness"] = "ps-awareness";
    PricingStrategyQuestion["GeneralPerception"] = "ps-general-perception";
    PricingStrategyQuestion["PoorQuality"] = "ps-poor-quality";
    PricingStrategyQuestion["GoodDeal"] = "ps-good-deal";
    PricingStrategyQuestion["ApproachingExpensive"] = "ps-approaching-expensive";
    PricingStrategyQuestion["BeyondConsideraton"] = "ps-beyond-consideration";
    PricingStrategyQuestion["OtherInfluence"] = "ps-other-influence";
})(PricingStrategyQuestion || (PricingStrategyQuestion = {}));
export var MarketingCampaignEffectivenessQuestion;
(function (MarketingCampaignEffectivenessQuestion) {
    MarketingCampaignEffectivenessQuestion["Solutions"] = "mce-solutions";
    MarketingCampaignEffectivenessQuestion["InHouseSolution"] = "mce-in-house-solution";
    MarketingCampaignEffectivenessQuestion["ThirdPartySolution"] = "mce-third-party-solution";
    MarketingCampaignEffectivenessQuestion["NoSolution"] = "mce-no-solution";
    MarketingCampaignEffectivenessQuestion["SolutionRating"] = "mce-solution-rating";
    MarketingCampaignEffectivenessQuestion["SolutionRatingExplanation"] = "mce-solution-rating-explanation";
    MarketingCampaignEffectivenessQuestion["ImprovementAreas"] = "mce-improvement-areas";
    MarketingCampaignEffectivenessQuestion["MainReason"] = "mce-main-reason";
    MarketingCampaignEffectivenessQuestion["Channels"] = "mce-channels";
    MarketingCampaignEffectivenessQuestion["ChannelsUsage"] = "mce-channels-usage";
    MarketingCampaignEffectivenessQuestion["ChannelsRanked"] = "mce-channels-ranked";
})(MarketingCampaignEffectivenessQuestion || (MarketingCampaignEffectivenessQuestion = {}));
export var MarketAnalysisQuestion;
(function (MarketAnalysisQuestion) {
})(MarketAnalysisQuestion || (MarketAnalysisQuestion = {}));
export var TargetProductProfileQuestion;
(function (TargetProductProfileQuestion) {
    TargetProductProfileQuestion["CurrentLocation"] = "tpp-current-location";
    TargetProductProfileQuestion["EUScreener"] = "tpp-eu-screener";
    TargetProductProfileQuestion["NonEUScreener"] = "tpp-non-eu-screener";
    TargetProductProfileQuestion["ConditionUnmetNeeds"] = "tpp-condition-unmet-needs";
    TargetProductProfileQuestion["ConditionEconomicBurden"] = "tpp-condition-economic-burden";
    TargetProductProfileQuestion["DrugStrengths"] = "tpp-drug-strengths";
    TargetProductProfileQuestion["DrugWeaknesses"] = "tpp-drug-weaknessses";
    TargetProductProfileQuestion["RateAttributes"] = "tpp-rate-attributes";
    TargetProductProfileQuestion["RatingRationale"] = "tpp-rating-rationale";
    TargetProductProfileQuestion["ClinincalComparatorsAppropriate"] = "tpp-cc-appropriate";
    TargetProductProfileQuestion["ClinicalComparatorsOE"] = "tpp-cc-oe";
    TargetProductProfileQuestion["ClinicalComparators"] = "ttp-cc";
    TargetProductProfileQuestion["ProductManage"] = "tpp-product-manage";
    TargetProductProfileQuestion["AcceptableWACPrice"] = "tpp-acceptable-wac-price";
    TargetProductProfileQuestion["PricingComparatorsOE"] = "tpp-pricing-comparator-oe";
    TargetProductProfileQuestion["PricingComparators"] = "tpp-pricing-comparator";
    TargetProductProfileQuestion["ProductLowPrice"] = "tpp-product-low-price";
    TargetProductProfileQuestion["ProductMediumPrice"] = "tpp-product-mid-price";
    TargetProductProfileQuestion["ProductHighPrice"] = "tpp-high-price";
    TargetProductProfileQuestion["HTAFrance"] = "tpp-hta-france";
    TargetProductProfileQuestion["HTAGermany"] = "tpp-hta-germany";
    TargetProductProfileQuestion["MoHReimbursement"] = "tpp-moh-reimbursement";
    TargetProductProfileQuestion["AIFAReimbursement"] = "tpp-aifa-reimbursement";
    TargetProductProfileQuestion["InnovativeStatus"] = "tpp-innovative-status";
    TargetProductProfileQuestion["UKOutcomes"] = "tpp-uk-outcomes";
    TargetProductProfileQuestion["CanadaReimbursement"] = "tpp-canada-reimbursement";
    TargetProductProfileQuestion["CanadaUnaidedPricing"] = "tpp-canada-unaided-pricing";
    TargetProductProfileQuestion["ProductAcceptableListPrice"] = "tpp-product-acceptable-list-price";
    TargetProductProfileQuestion["ProductPremiumDiscount"] = "tpp-product-premium-discount";
    TargetProductProfileQuestion["RegionalAccessVariation"] = "tpp-regional-access-variation";
    TargetProductProfileQuestion["InsititutionalFormulary"] = "tpp-institutional-formulary";
})(TargetProductProfileQuestion || (TargetProductProfileQuestion = {}));
export var TargetProductProfileMessage;
(function (TargetProductProfileMessage) {
    TargetProductProfileMessage["Stimulus"] = "tpp-stimulus";
    TargetProductProfileMessage["TPP"] = "tpp-tpp";
})(TargetProductProfileMessage || (TargetProductProfileMessage = {}));
export default {
    SurveyTemplateType: extend(surveyTemplateTypeMap),
};
export var ExternalSourcingVendor;
(function (ExternalSourcingVendor) {
    ExternalSourcingVendor[ExternalSourcingVendor["AlphaSights"] = 1] = "AlphaSights";
    ExternalSourcingVendor[ExternalSourcingVendor["ColemanResearch"] = 2] = "ColemanResearch";
    ExternalSourcingVendor[ExternalSourcingVendor["GLG"] = 3] = "GLG";
    ExternalSourcingVendor[ExternalSourcingVendor["Toluna"] = 4] = "Toluna";
    ExternalSourcingVendor[ExternalSourcingVendor["Trinity"] = 5] = "Trinity";
    ExternalSourcingVendor[ExternalSourcingVendor["Dynata"] = 6] = "Dynata";
    ExternalSourcingVendor[ExternalSourcingVendor["M3"] = 7] = "M3";
    ExternalSourcingVendor[ExternalSourcingVendor["MedSurvey"] = 8] = "MedSurvey";
    ExternalSourcingVendor[ExternalSourcingVendor["Reckner"] = 9] = "Reckner";
    ExternalSourcingVendor[ExternalSourcingVendor["SHG"] = 10] = "SHG";
    ExternalSourcingVendor[ExternalSourcingVendor["Medefield"] = 11] = "Medefield";
    ExternalSourcingVendor[ExternalSourcingVendor["AllGlobal"] = 12] = "AllGlobal";
    ExternalSourcingVendor[ExternalSourcingVendor["AtlasPrimary"] = 13] = "AtlasPrimary";
    ExternalSourcingVendor[ExternalSourcingVendor["Sago"] = 14] = "Sago";
    ExternalSourcingVendor[ExternalSourcingVendor["Konovo"] = 15] = "Konovo";
})(ExternalSourcingVendor || (ExternalSourcingVendor = {}));
